import React from 'react'
import { ButtonGroup } from '@pandiafi/design-system'

type LockedTenantChoiceProps = {
  label: string
  tenantName: string
}

export const LockedTenantChoice: React.FC<LockedTenantChoiceProps> = ({
  label,
  tenantName,
}) => (
  <ButtonGroup
    className="w-full"
    onChange={() => undefined}
    suggestions={[{ id: label, label }]}
    value={undefined}
    disabled
    aria-label={tenantName}
  />
)
